import React, { useState, useEffect } from "react";
import { VerifyEmailStyle } from "./VerifyEmail.styled";
import Footer from "../../components/footer/Footer";
import TopBar2 from "../../components/TopBar/TopBar2";
import { useParams } from "react-router-dom";
import { checkEmail } from "../../api/EmailApi";
import { useQuery } from "@tanstack/react-query";
import { HeadingStyles2 } from "../../styles/HeadingStyles";

const VerifiedComponent = ({ verified }) => {
  return (
    <div className="body">
      {verified === 1 && (
        <>
          <HeadingStyles2>Ocufii Two-Step Verification</HeadingStyles2>
          <img
            src={`${process.env.PUBLIC_URL}/acceptIcon.png`}
            alt="Logo"
            className="imgLogo"
          />
          <p className="smsTxt">Verified!</p>
        </>
      )}
      {verified === 2 && (
        <>
          <HeadingStyles2>Ocufii Two-Step Verification</HeadingStyles2>
          <img
            src={`${process.env.PUBLIC_URL}/rejectIcon.png`}
            alt="Logo"
            className="imgLogo"
          />
          <p className="smsTxt">Verify Family Link Expired!</p>
          {/* <p className='smsTxt'>It look like the delete beacon link has expired.</p> */}
        </>
      )}
      {verified === 3 && (
        <>
          <HeadingStyles2>Ocufii Two-Step Verification</HeadingStyles2>
          <img
            src={`${process.env.PUBLIC_URL}/rejectIcon.png`}
            alt="Logo"
            className="imgLogo"
          />
          <p className="smsTxt">Link Expired!</p>
          <p className="smsTxt">
            It look like the Verify Family link has expired.
          </p>
          <p className="smsTxt2">
            Having repeated issues with Family Link? Contact support
          </p>
        </>
      )}
    </div>
  );
};
const VerifyTrustedContactLink = () => {
  const [loading, setLoading] = useState(true);
  const [verified, setVerified] = useState(3);
  const { email, token } = useParams();
  const [enableAPI, setEnableAPI] = useState(false);

  const {
    status: VerifyTrustedContactLinkStatus,
    data: VerifyTrustedContactLinkData,
    error: VerifyTrustedContactLinkError,
  } = useQuery({
    queryKey: ["RemoveLockBeacon", email, token],
    queryFn: () => checkEmail("RemoveLockBeacon", email, token),
    enabled: enableAPI,
    retry: false,
  });

  useEffect(() => {
    if (VerifyTrustedContactLinkStatus === "success" && VerifyTrustedContactLinkData) {
      if (VerifyTrustedContactLinkData.status === 400) {
        setVerified(2);
      } else {
        setVerified(1);
      }
      setEnableAPI(false);
    }
    if (VerifyTrustedContactLinkStatus === "error") {
      setVerified(3);
      setEnableAPI(false);
    }
  }, [VerifyTrustedContactLinkStatus, VerifyTrustedContactLinkData]);

  useEffect(() => {
    if (email || token) {
      setEnableAPI(true);
    } else {
      setEnableAPI(false);
    }
  }, [email, token]);

  return (
    <VerifyEmailStyle>
      <TopBar2 />
      {VerifyTrustedContactLinkStatus === "loading" ? (
        <div className="body">
          <p className="description">Loading ...</p>
        </div>
      ) : (
        <VerifiedComponent verified={verified} />
      )}
      <Footer />
    </VerifyEmailStyle>
  );
};

export default VerifyTrustedContactLink;
